import TinyMce from "components/GbCpn/TinyMce";
import SidebarLayout from "components/Layout/Layout";
import { useTheme } from "components/provider/theme";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useRef } from 'react'
import { API_URL } from "env";
import { toast } from "react-toastify";

const EventDetail = () => {
    const { theme } = useTheme();
    const { id } = useParams();
    const [languageList, setLanguageList] = useState(['en', 'vi']);
    const [selectedLang, setSelectedLang] = useState<string>();
    const [eventType, setEventType] = useState('');
    const [title, setTitle] = useState({
        en: '',
        vi: ''
    });
    const [subTitle, setSubTitle] = useState({
        en: '',
        vi: ''
    });
    const [description, setDescription] = useState({
        en: '',
        vi: ''
    });

    function checkData() {
        for (const lang of languageList) {
            if (!title[lang as 'en' | 'vi']) {
                toast.error(`Title (${lang.toUpperCase()}) is required`);
                return false;
            }
            if (!subTitle[lang as 'en' | 'vi']) {
                toast.error(`Sub Title (${lang.toUpperCase()}) is required`);
                return false;
            }
            if (!description[lang as 'en' | 'vi']) {
                toast.error(`Description (${lang.toUpperCase()}) is required`);
                return false;
            }
        }
        return true;
    }

    async function getContent() {
        if (!id) return;
        try {
            const response = await fetch(`${API_URL}api/v1/be/events/${id}`,
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    },
                }
            );
            const data = await response.json();
            setEventType(data.data.type);
            setTitle({
                en: data.data.title.en,
                vi: data.data.title.vi
            });
            setSubTitle({
                en: data.data.subtitle.en,
                vi: data.data.subtitle.vi
            });
            const desc = JSON.parse(data.data.description);
            setDescription({
                en: desc.en,
                vi: desc.vi
            });
        }
        catch (error) {
            console.error('There was a problem with the fetch operation:', error);
        }
    }

    async function saveContent() {
        if (!id) return;
        if (checkData()) {
            try {
                const response = await fetch(`${API_URL}api/v1/be/events/${id}`, {
                    method: "PUT",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    },
                    body: JSON.stringify({
                        title,
                        subtitle: subTitle,
                        description,
                        type: eventType,
                    })
                });
                const data = await response.json();
                if (data.status) {
                    toast.success('Event updated successfully');
                    window.location.pathname = '/events';
                } else {
                    toast.error(data.message || 'Failed to update event');
                }   
            }
            catch (error) {
                console.error('There was a problem with the fetch operation:', error);
            }
        }
        else {
            toast.error('Please fix the errors before saving.');
        }
    }

    useEffect(() => {
        getContent();
    }, [ id ]);

    useEffect(() => {
        getContent();
    }, []);


    return (<SidebarLayout
        title={(
            <h4 className={`text-2xl font-bold !m-0 ${theme === "light" ? 'text-gray-800' : ''} py-4`}>
                Event Dashboard
            </h4>
        )}
    >
        <div className="w-full ">
            {id ? (
                <div className={`rounded-lg shadow-sm ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} p-4`}>
                    <h2 className="text-xl font-semibold mb-4">Event Detail - ID: {id}</h2>
                    <div className="mb-4">
                        <select className={`p-2 w-full rounded border ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : 'bg-white text-black border-gray-300'}`}
                            value={selectedLang}
                            onChange={(e) => {
                                setSelectedLang(e.target.value);
                                console.log('data', title, subTitle, description);
                                console.log("Selected Language:", e.target.value);
                            }
                            }
                        >
                            <option value="" disabled>Select Language</option>
                            <option value="en">English</option>
                            <option value="vn">Vietnamese</option>
                        </select>
                    </div>
                    <div className="mb-4">
                        <input
                            type="text"
                            className={`w-full p-2 rounded border ${theme === 'dark'
                                    ? 'bg-gray-700 text-white border-gray-600'
                                    : 'bg-white text-black border-gray-300'
                                }`}
                            placeholder="Title"
                            value={selectedLang === 'vn' ? title.vi : title.en}   // dùng value thay vì defaultValue
                            onChange={(e) => {
                                if (selectedLang === 'en') {
                                    setTitle((prev) => ({ ...prev, en: e.target.value }));
                                } else if (selectedLang === 'vn') {
                                    setTitle((prev) => ({ ...prev, vi: e.target.value }));
                                }
                            }}
                        />

                    </div>
                    <div className="mb-4">
                        <input type="text"
                            className={`w-full p-2 rounded border ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : 'bg-white text-black border-gray-300'}`}
                            placeholder="Subtitle"
                            value={selectedLang === 'vn' ? subTitle.vi : subTitle.en}
                            onChange={(e) => {
                                setSubTitle(prev => ({
                                    ...prev,
                                    en: selectedLang === 'en' ? e.target.value : prev.en,
                                    vi: selectedLang === 'vn' ? e.target.value : prev.vi
                                }));
                            }}
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block mb-2 font-medium">Event Type:</label>
                        <select
                            value={eventType}
                            onChange={(e) => setEventType(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded"
                        >
                            <option value="news">News</option>
                            <option value="update">Update</option>
                            <option value="announcement">Announcement</option>
                            <option value="promotion">Promotion</option>
                            <option value="challenge">Challenge</option>
                            <option value="other">Other</option>
                        </select>
                    </div>
                    <div className="mb-4">
                        <TinyMce
                            defaultValue={selectedLang === 'vn' ? description.vi : description.en}
                            onChange={(content) => {
                                setDescription(prev => ({
                                    ...prev,
                                    en: selectedLang === 'en' ? content : prev.en,
                                    vi: selectedLang === 'vn' ? content : prev.vi
                                }));
                            }}
                        />
                    </div>
                    <div className="w-full flex justify-end mt-4" >
                        <button
                            onClick={() => {
                                saveContent();
                            }}
                            className={`px-4 py-2 rounded ${theme === 'dark' ? 'bg-blue-600 !text-white hover:bg-blue-700' : 'bg-blue-500 !text-white hover:bg-blue-600'}`}>Save Changes</button>
                    </div>
                </div>
            ) : (
                <div className={`rounded-lg shadow-sm ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} p-4`}>
                    <h2 className="text-xl font-semibold mb-4">No Event Selected</h2>
                    <p>Please select an event to view its details.</p>
                </div>
            )
            }
            
        </div>
    </SidebarLayout >
    );
}

export default EventDetail;
